// extracted by mini-css-extract-plugin
export default {"candidatePage":"candidate_candidatePage__xTrCN"};